<script>
import Collapsible from '@/components/Collapsible'
import Button from '@/components/Button'
import DeviceUtils from '@/utils/deviceUtils'
import StringUtils from '@/utils/stringUtils'
import ArrayUtils from '@/utils/arrayUtils'

export default
{
    name: 'useful-info-collapsible',

    props:
    {
        info: { required: true }
    },

    created ()
    {
    },

    render () 
    {
        const title = this.info.title
        const phoneNumbers = StringUtils.getFrenchPhoneNumbersInString(this.info.description)
        const WebUrls = StringUtils.getUrlsInString(StringUtils.removeHtmlTags(this.info.description), 'https?')
        var description = this.info.description

        for (let number of phoneNumbers)
        {
            const excludeFaxNumberRegex = number => new RegExp(`fax.{0,10}${number}`, 'gmi')
            if (this.info.description.match(excludeFaxNumberRegex(number)))
            {
                console.log(number, 'detected as fax number... uhm probably is 🙃')
                ArrayUtils.removeByValue(phoneNumbers, number)
                continue
            }

            phoneNumbers[phoneNumbers.indexOf(number)] = StringUtils.formatPhoneNumber(number)
        }

        for (let url of WebUrls)
        {
            description = description.replace(url, `<a target="_system" href="${url}">${url}</a>`)
        }

        return (
            <collapsible class='useful-info-collapsible' title={title} description={description} description-overflow={{chars: 50, lines: 3}}
                actions={this.createInfoCollapsibleActions()}>
                {
                    phoneNumbers.length > 0 && phoneNumbers.map(num => (
                        <div class='phone-number-actions'>
                            <Button icon={require('@/assets/img/call.svg')} text={'Appeler le ' + num} on-click={()=>window.open('tel://' + num, '_system')} />
                            <Button icon={require('@/assets/img/copy.svg')} text={'Copier'} type='light' on-click={()=>DeviceUtils.copy(num)} />
                        </div>
                    ))
                }
            </collapsible>
        )
    },

    mounted ()
    {
    },

    data () 
    {
        return {
        }
    },

    computed:
    {
    },

    methods:
    {
        createInfoCollapsibleActions ()
        {
            const isSavedAsFavorite = this.$store.state.favorites.usefulInfos.includes(this.info.id)

            const onClick = () =>
            {
                this.$store.commit('favorites/setUsefulInfoState', {usefulInfoId: this.info.id, isFavorite: !isSavedAsFavorite})
            }

            const collapsibleActions =
            <inline-svg add-class={`like ${isSavedAsFavorite ? 'filled' : ''}`}
                on-click={onClick} src={require('@/assets/img/heart.svg')} />

            return collapsibleActions
        }
    },

    components:
    {
        Collapsible,
        Button
    }
}
</script>

<style lang='less'>
.useful-info-collapsible
{
    &.collapsible
    {
        border-radius: 10px;
        border-width: 1px;
        box-shadow: 0 3px 11px 1px rgba(0, 0, 0, 0.1);

        .content
        {
            .title
            {
                font-weight: 600;
            }
        }

        .actions
        {
            .like
            {
                height: 22px;
                fill: var(--theme-text-color-light);

                .inside
                {
                    fill: transparent;
                }

                &.filled
                {
                    .border, .inside
                    {
                        fill: var(--theme-love-color);
                    }
                }
            }
        }

        .expandable
        {
            .phone-number-actions
            {
                display: flex;
                flex-direction: row;
                margin-top: 4px;

                .button
                {
                    padding: 9px 11px;

                    &:first-of-type
                    {
                        width: 100%;
                    }
                    &:last-of-type
                    {
                        margin-left: 5px;
                    }
                }
            }
        }

        .expand
        {
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/UsefulInfoCollapsible.vue